var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-nav flex",class:{ ['pos-' + _vm.position]: true }},[_c('logo',{attrs:{"mode":"horizontal"}}),_vm._v(" "),_c('div',{staticClass:"box grow flex nav-container"},[_c('vue-scroll',{staticClass:"box grow"},[_c('Nav',{attrs:{"mode":"horizontal"},on:{"push-page":_vm.pushPage}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }